import { Input } from "@/app/admin/_common/ui/input";
import { Label } from "@/app/admin/_common/ui/label";
import { Textarea } from "@/app/admin/_common/ui/textarea";
import { cn } from "@/app/_utils/cn";

import { HIGHLIGHT_CLASSES } from "./highlight";

export default function DetailsPane({
  name,
  description,
  onChange,
  highlighted,
}: {
  name: string;
  description: string;
  onChange: (patch: { name?: string; description?: string }) => void;
  highlighted: boolean;
}) {
  return (
    <div className="mx-auto flex w-full max-w-[560px] flex-col gap-6">
      <h2 className="my-0 px-1 text-[20px] font-semibold tracking-tight text-foreground">Details</h2>

      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-1.5">
          <Label htmlFor="checklist-name">Name</Label>
          <Input
            id="checklist-name"
            value={name}
            placeholder="e.g. Private Event"
            onChange={(e) => onChange({ name: e.target.value })}
            className={cn(highlighted && HIGHLIGHT_CLASSES)}
          />
        </div>
        <div className="flex flex-col gap-1.5">
          <Label htmlFor="checklist-description">Description</Label>
          <Textarea
            id="checklist-description"
            value={description}
            placeholder="What this checklist is for"
            onChange={(e) => onChange({ description: e.target.value })}
            rows={3}
          />
        </div>
      </div>
    </div>
  );
}
